import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import WhatIfWizardCollectionStepperTemplate
  from 'Views/Page/Content/Modal/Layouts/WhatIfWizardCollectionStepperTemplate';
import Layout from './Layout';
import metaOverrideSet from '../../../MetaOverrideSet';

const VirualAccountsSetupStepper = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <WhatIfWizardCollectionStepperTemplate
      layout={Layout}
      collection={resource.attr('facetPlanVirtualAccountSetups')}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

export default VirualAccountsSetupStepper;
